import { DateTime } from 'luxon';

interface FailedFolderDTO {
    id?: number;
    entityId?: string;
    entityType?: string;
    projectFolderLink?: string;
    contractLink?: string;
    productionLink?: string;
    estimationLink?: string;
    errorMessage?: string;
    resolved?: boolean;
    createdAt?: string | null;
    observations?: string;
}

export default class FailedFolder {
    id: number;
    entityId: string;
    entityType: string;
    projectFolderLink: string;
    contractLink: string;
    productionLink: string;
    estimationLink: string;
    errorMessage: string;
    resolved: boolean;
    createdAt: DateTime | null;
    observations: string;

    constructor(dto: Partial<FailedFolderDTO> = {}) {
        this.id = dto.id ?? 0;
        this.entityId = dto.entityId ?? '';
        this.entityType = dto.entityType ?? '';
        this.projectFolderLink = dto.projectFolderLink ?? '';
        this.contractLink = dto.contractLink ?? '';
        this.productionLink = dto.productionLink ?? '';
        this.estimationLink = dto.estimationLink ?? '';
        this.errorMessage = dto.errorMessage ?? '';
        this.resolved = dto.resolved ?? false;
        this.createdAt = dto.createdAt ? DateTime.fromISO(dto.createdAt) : null;
        this.observations = dto.observations ?? '';
    }
}
